
import cpl from '../../assets/images/projects/cpl.webp'
import bap from '../../assets/images/projects/bap.webp'
import bos from '../../assets/images/projects/bos.webp'
import ezg from '../../assets/images/projects/ezg.webp'
import netpulse from '../../assets/images/projects/netpulse.webp'
import rsh from '../../assets/images/projects/rsh.webp'
import formatdaddy from '../../assets/images/projects/formatdaddy.webp'
export const projects = [
    {
        name: 'Core Programming Logic',
        link: 'https://medium.com/@khwahish.dev/building-a-timeless-core-logic-library-for-developers-a98a8bd78b64',
        repo: 'https://github.com/kwhx/core-programming-logic',
        main: cpl,
        minor: cpl,
        description: 'A comprehensive guide to foundational programming concepts',
    },
    {
        name: 'Blackstar OS',
        link: '#',
        repo: '#',
        main: bos,
        minor: bos,
        description: 'Blackstar OS is a sovereign, amnesic substrate engineered in rust for those who view digital footprints as a structural vulnerability. It doesn\'t just hide your presence, it ensures you never existed in the first place [ONGOING]',
    },
    {
        name: 'BAP [Blackstar Anonymity Protocol]',
        link: '#',
        repo: '#',
        main: bap,
        minor: bap,
        description: 'Blackstar Anonymity Protocol is a  post-quantum protocol utilizing Poisson-perturbed traffic and Kyber-grade lattice cryptography. It renders global passive adversaries mathematically obsolete by making information indistinguishable from the background noise of the universe [ONGOING]',
    },
    {
        name: 'EzGit',
        link: 'https://medium.com/@khwahish.dev/reimagining-git-for-humans-not-manuals-6351d2c937ae',
        repo: 'https://github.com/kwhx/ezgit',
        main: ezg,
        minor: ezg,
        description: 'EzGit is a Git TUI that abstracts all repository operations into an interactive selection workflow, eliminating the need to recall and manually execute individual Git commands',
    },
    {
        name: 'RootShell',
        link: 'https://0xrootshell.netlify.app/',
        repo: 'https://github.com/kwhx/0xrootshell',
        main: rsh,
        minor: rsh,
        description: 'RootShell is a cross-platform terminal that replaces traditional command-line syntax with natural language inputs, providing a simplified and high-performance user interaction model',
    },
    {
        name: 'Netpulse',
        link: 'https://medium.com/@khwahish.dev/making-network-monitoring-feel-alive-b4e99e76f82f',
        repo: 'https://github.com/kwhx/netpulse',
        main: netpulse,
        minor: netpulse,
        description: 'NetPulse is a cross-platform, terminal-based network diagnostics utility that delivers accurate bandwidth and latency measurements through a lightweight CLI, enabling fast and reliable speed testing on both Windows and Linux',
    },
    {
        name: 'FormatDaddy',
        link: 'https://formatdaddy.vercel.app/',
        repo: '#',
        main: formatdaddy,
        minor: formatdaddy,
        description: 'FormatDaddy is a privacy-first, browser-based document formatting platform engineered for handling sensitive content. Its client-side processing engine executes all formatting operations locally within the user’s browser, ensuring that documents are never transmitted to external servers, while delivering near-instant transformation, real-time preview, and secure download workflows',
    }
];